import { useMemo } from 'react';

import { BANK_DOSSIER_MOCK_ENABLED } from '../../../constants/bankDossier';
import { WorkOrderData } from '../types';
import { getBankDossier } from './mock';
import { BankDossier } from './types';

/**
 * Resolves the bank dossier of a work order: the API field when present,
 * the deterministic mock while the backend does not ship it, `null` otherwise.
 */
export const resolveBankDossier = (
  workOrder: WorkOrderData | null | undefined
): BankDossier | null => {
  if (!workOrder) return null;
  if (workOrder.bank_dossier) return workOrder.bank_dossier;
  return BANK_DOSSIER_MOCK_ENABLED ? getBankDossier(workOrder) : null;
};

export const useBankDossier = (
  workOrder: WorkOrderData | null | undefined
): BankDossier | null =>
  useMemo(() => resolveBankDossier(workOrder), [workOrder]);

/** Files that belong to the work order itself (not to sibling requests of the folder). */
export const ownFiles = (
  dossier: BankDossier,
  workOrderId: number
): BankDossier['files'] =>
  dossier.files.filter((file) => file.work_order_id === workOrderId);

export const latestReport = (
  dossier: BankDossier,
  workOrderId: number
): BankDossier['files'][number] | null =>
  ownFiles(dossier, workOrderId).find((file) => file.is_latest_report) ?? null;

export * from './types';
